import { Component, type ErrorInfo, type ReactNode } from "react";
import { compliance, phoneHref } from "./lib/compliance";

type Props = { children: ReactNode };
type State = { failed: boolean };

export class ErrorBoundary extends Component<Props, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error(error, info.componentStack);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    const call = phoneHref();
    return (
      <main className="crash">
        <h1>The rate check stalled</h1>
        <p>Refresh the page. Your numbers were not sent anywhere.</p>
        {call ? <a href={call}>Call {compliance.phone}</a> : null}
      </main>
    );
  }
}
